import { render, staticRenderFns } from "./commonFoot.vue?vue&type=template&id=55b5a06c&scoped=true"
import script from "./commonFoot.vue?vue&type=script&lang=js"
export * from "./commonFoot.vue?vue&type=script&lang=js"
import style0 from "./commonFoot.vue?vue&type=style&index=0&id=55b5a06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5a06c",
  null
  
)

export default component.exports